import emailjs from 'emailjs-com';

/**
 * Sends an email using Email.js.
 * 
 * @param {Object} formData - The form data containing name, email, and message.
 * @param {string|null} captchaToken - The completed reCAPTCHA response.
 * @returns {Promise} - Resolves if EmailJS accepts the email, otherwise rejects.
 */
export const sendEmail = async (formData, captchaToken) => {
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userId = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    // Never report success when no email service is configured.
    if (!serviceId || !templateId || !userId) {
        throw new Error('EmailJS configuration is incomplete');
    }

    if (process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY && !captchaToken) {
        throw new Error('A completed reCAPTCHA is required');
    }

    const formDataEmailJSFormat = {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
        ...(captchaToken ? { 'g-recaptcha-response': captchaToken } : {})
    };

    return emailjs.send(serviceId, templateId, formDataEmailJSFormat, userId);
};
